export const packageName = 'jiraProformaRequestTypeConfig';
export const teamName = 'jsm-request-intake';
